import React from 'react';
import SectionHeader from './SectionHeader';

export default function MoodGrid({ data, columns = 3 }) {
  const colClass = columns === 3 ? 'md:grid-cols-2 lg:grid-cols-3' : 'md:grid-cols-2';
  return (
    <section className="section-pad">
      <div className="container-narrow">
        <SectionHeader chapter={data.chapter} label={data.label} heading={data.heading} />
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-8">
            <p className="font-serif text-[19px] leading-[1.75] text-[color:var(--bx-bone)]/85">{data.body}</p>
          </div>
          {data.meta && (
            <div className="lg:col-span-4 space-y-5">
              {data.meta.map((m, i) => (
                <div key={i} className="border-l border-[color:var(--bx-gold)]/30 pl-4">
                  <div className="font-sc text-[10px] gold-text tracking-[0.4em] mb-1">{m.k}</div>
                  <div className="font-serif text-[16px] text-[color:var(--bx-bone)]/85">{m.v}</div>
                </div>
              ))}
            </div>
          )}
        </div>
        {data.paragraphs && (
          <div className="grid lg:grid-cols-12 gap-10 mb-12">
            <div className="lg:col-span-8 space-y-5">
              {data.paragraphs.map((p, i) => (
                <p key={i} className="font-serif text-[18px] leading-[1.75] text-[color:var(--bx-bone)]/85">{p}</p>
              ))}
            </div>
          </div>
        )}
        <div className="grid grid-cols-1 gap-8 max-w-5xl mx-auto">
          {data.plates.map((pl, i) => (
            <div key={i} className="plate w-full" style={{ aspectRatio: "21 / 9" }}>
              <img src={pl.img} alt={pl.title} loading="lazy" />
              <div className="plate-meta">
                <div>
                  <div className="font-sc text-[10px] gold-text tracking-[0.4em]">{pl.n}</div>
                  <div className="font-sc text-[10px] text-[color:var(--bx-bone)]/80 tracking-[0.32em] mt-1">{pl.title}</div>
                </div>
                <div className="font-mono text-[10px] text-[color:var(--bx-muted)]">21 : 9</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
